import React, { ChangeEvent, RefObject } from "react";
import { Button } from "src/business-types/grocery/components/Button";
import InputBox from "src/business-types/grocery/components/InputBox";
import DropdownSelect from "src/business-types/grocery/components/DropdownSelect";
import iconMap from "src/assets/icons/Icons";
import { notifyWarning } from "src/assets/toastService";

interface Props {
    usedPopup: boolean;
    searchTerm: string;
    setSearchTerm: (v: string) => void;
    deleted: boolean;
    setDeleted: (v: boolean) => void;
    filterCategory: string;
    setFilterCategory: (v: string) => void;
    category: any[];
    createProduct: boolean;
    showDropdown: boolean;
    setShowDropdown: (v: boolean) => void;
    onAddProduct: () => void;
    onExport: () => void;
    onImportClick: () => void;
    onImportFile: (e: ChangeEvent<HTMLInputElement>) => void;
    fileInputRef: RefObject<HTMLInputElement>;
}

export default function ProductsToolbar({
    usedPopup, searchTerm, setSearchTerm,
    deleted, setDeleted,
    filterCategory, setFilterCategory, category,
    createProduct, showDropdown, setShowDropdown,
    onAddProduct, onExport, onImportClick, onImportFile, fileInputRef,
}: Props) {
    const DownArrow = iconMap["down"];

    return (
        <div className="flex justify-end items-center h-[12%]">
            <div className="w-full flex gap-2 pr-12 justify-end">

                {/* Search (popup mode) */}
                {usedPopup && (
                    <div className="col-span-2 md:col-span-3 flex justify-center items-center gap-2">
                        <p>Search</p>
                        <InputBox
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search Product"
                        />
                    </div>
                )}

                {/* View Deleted */}
                {!usedPopup && (
                    <div className="flex items-center cursor-pointer gap-2" onClick={() => setDeleted(!deleted)}>
                        <input
                            type="checkbox"
                            className="w-5 h-5"
                            checked={deleted}
                            onChange={(e) => setDeleted(e.target.checked)}
                        />
                        <p className="w-40">View deleted</p>
                    </div>
                )}

                {/* Category Filter */}
                <div className="col-span-2 md:col-span-2 flex flex-col justify-center items-start w-80 mt-3">
                    <p className="text-sm font-medium col-span-2 w-28 -mt-2">Category Type</p>
                    <div className="w-52 h-fit">
                        <DropdownSelect
                            titleofSelect="All Category"
                            name="category_id"
                            value={filterCategory}
                            options={category.map((c) => ({
                                _id: c._id.$oid,
                                CategoryName: c.name,
                                otherName: c.secondName,
                            }))}
                            onChange={(e) => setFilterCategory(e)}
                        />
                    </div>
                </div>

                {/* Add + More Options */}
                {!usedPopup && createProduct && (
                    <Button
                        label="+ Product"
                        variant="ThemeBase"
                        onClick={onAddProduct}
                        className="p-2 w-fit h-fit mt-4"
                    />
                )}
                {!usedPopup && (
                    <Button
                        variant="ThemeBase"
                        onClick={() => notifyWarning("Comming Zoon")}
                        icon={DownArrow}
                        iconPosition="right"
                        label="More Options"
                        className="p-2 w-fit h-fit mt-4"
                    />
                )}

                {/* Hidden file input */}
                <input
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    ref={fileInputRef}
                    className="hidden"
                    onChange={onImportFile}
                />

                {/* Dropdown */}
                {showDropdown && (
                    <div className="absolute mt-16 right-16 bg-white border rounded shadow-lg z-10 w-32">
                        <button
                            className="w-full px-4 py-2 text-left hover:bg-gray-100"
                            onClick={() => { onExport(); setShowDropdown(false); }}
                        >
                            Export
                        </button>
                        <button
                            className="w-full px-4 py-2 text-left hover:bg-gray-100"
                            onClick={() => { onImportClick(); setShowDropdown(false); }}
                        >
                            Import
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}